module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "imageloader-background",
    class: {
      'active': !_vm.imgLoaded
    }
  }), _vm._v(" "), _c('img', {
    ref: "myImg",
    staticClass: "imageloader-image",
    style: ({
      'opacity': _vm.imgOpacity + '!important'
    }),
    attrs: {
      "src": 'static/img/content/' + _vm.imgSrc
    },
    on: {
      "load": function($event) {
        _vm.thisLoaded()
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3325cfa0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageLoader.vue
// module id = 135
// module chunks = 2